export enum PricingEnginePermission {
  view = "pricingEngine.view",
  manage = "pricingEngine.manage",
}

export const canAccessPricingEngine = (hasViewPermission: boolean): boolean => hasViewPermission;
